import { Component, OnInit, ViewChild } from '@angular/core';
import { ErrorModel } from './../../Shared/Model/error/error-model';
import { AdminService } from './../../Shared/Services/Admin/admin.service';
import { AppTypes, ProjectPermissionModal} from 'src/app/Shared/Model/projectPermission/projectPermissionModal';
import { MDBModalRef } from 'angular-bootstrap-md';
import { ConfigLoaderService } from 'src/app/Shared/Services/Config/config-loader.service'
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectPermissionService } from '../../Shared/Services/ProjectPermission/project-permission.service'
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { ErrorServiceService } from 'src/app/Shared/Services/Error/error-service.service';
declare var $: any;

@Component({
  selector: 'app-project-permission',
  templateUrl: './project-permission.component.html',
  styleUrls: ['./project-permission.component.scss']
})
export class ProjectPermissionComponent implements OnInit {
  dataSource = new MatTableDataSource();
  hasData: boolean=true;
  displayedColumns!: string[];
  columns_to_display_in_table!: string[];
  appTypeList!: AppTypes[];
  appType: string = '';
  appName:string='';
  appName1:string='';
  projectPermissionModal: ProjectPermissionModal = new ProjectPermissionModal();
  clients: any;
  projects:any; 
  snackBarRef: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  durationInSeconds = 2;
  result: any;  
  ProjectPermissionSuccessMessage = "Project Permission is given Successfully.";
  RevokePermissionSuccessMessage = "Project Permission is Revoked Successfully.";
  ProjectPermissionErrorMessage = "Error in giving Project Permission.";
  ErrorMessage: string = "Error in Submitting.";
  showSubmitButton: boolean = false;
  
  group = new FormGroup({
    appType: new FormControl(null, Validators.required),
    clientType: new FormControl(null, Validators.required),
    projectType: new FormControl(null, [Validators.required]),
    userIds: new FormControl(null, [Validators.required]),
    isExcludeProjectUser: new FormControl(true)
  });

  @ViewChild('f', { static: false }) myForm!: any;
  
  constructor(public modalRef: MDBModalRef, private _snackBar: MatSnackBar,
    public _errorService: ErrorServiceService, public _adminService: AdminService, public _projectPermissionService: ProjectPermissionService, public _datePipe: DatePipe) { }

  ngOnInit(): void {
    if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
      this.projectPermissionModal.loggedInuserId = ConfigLoaderService.settings.DevValues.userName;
    }
    else {
      this.projectPermissionModal.loggedInuserId = ConfigLoaderService.settings.AppSettings.userId;
    }
    
    this.projectPermissionModal.isExcludeProjectUser = true;
    this.getAppType();
  }

  getAppType() {
    this._adminService
      .getAppTypeList(this.projectPermissionModal.loggedInuserId).subscribe(
        (data: any) => {
            this.appTypeList = data;
          })
  }
  appTypeChanged(appType:string){
    this.appName="SAP"+appType
    this._projectPermissionService.getClients(this.appName,this.projectPermissionModal.loggedInuserId).subscribe(
     ( data :any)=>  {
       this.clients = data;
  }
    )
}
clientTypeChanged(clientType:string){
  this._projectPermissionService.getProject(clientType,this.appName,this.projectPermissionModal.loggedInuserId).subscribe(
   ( data :any)=>  {
     this.projects = data;
     this.hasData = false;
})
}

projectTypeChanged(projectId: string, isExcludeProjectUser: string){ 
  this.GetProjectAccessUsers(projectId, isExcludeProjectUser)
}

OnCheckboxChanged(){
  let isExcludeProjectUserCheckbox  = document.getElementById('isExcludeProjUser') as HTMLInputElement;
  let excludeProjUser: string;
  if(isExcludeProjectUserCheckbox.checked == false)
  {
    this.projectPermissionModal.isExcludeProjectUser = false;
    excludeProjUser = 'N';
    this.GetProjectAccessUsers(this.projectPermissionModal.PROJECT_ID, excludeProjUser)
  }
  else{
    this.projectPermissionModal.isExcludeProjectUser = true;
    excludeProjUser = 'Y';
    this.GetProjectAccessUsers(this.projectPermissionModal.PROJECT_ID, excludeProjUser)
  }
}

GetProjectAccessUsers(projectId: string, isExcludeProjectUser: string){
  let isExcludeProjUser: string = 'Y';
  if(this.projectPermissionModal.isExcludeProjectUser == false)
  {
     isExcludeProjUser = 'N';
  }
  else{
    isExcludeProjUser = 'Y';
  }
  this._projectPermissionService.getProjectAccessUsers(projectId,isExcludeProjUser,this.projectPermissionModal.loggedInuserId).subscribe(
    ( data :any)=>  {
      this.result = data;
      if(data.length > 0)
      {       
        this.ConstructTheTable();
  }
  else{
    this.hasData = false;
  }
})
}

Revoke(cell:any) { 
  let isExcludeProjUser: string = 'Y';
  if(this.projectPermissionModal.isExcludeProjectUser == false)
  {
     isExcludeProjUser = 'N';
  }
  else{
    isExcludeProjUser = 'Y';
  }
 this._projectPermissionService.RevokeUserProjectAccess(this.projectPermissionModal.PROJECT_ID, cell["USER NAME"], this.projectPermissionModal.loggedInuserId).subscribe(
   (data: any)=> {
     if(data.toUpperCase() == "SUCCESS")
     {     
      this.GetProjectAccessUsers(this.projectPermissionModal.PROJECT_ID, isExcludeProjUser);      
      this.openSnackBar(this.RevokePermissionSuccessMessage);
     }
    },
     (error: any) => {
         this.openErrorSnackBar(this.ErrorMessage);
    }   
 )
}


openSnackBar(message: string) {
  this.snackBarRef = this._snackBar.open(
    message, 'OK', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: this.durationInSeconds * 1000,
    panelClass: ["custom-style"]
  });
}

openErrorSnackBar(message: string) {
  this.snackBarRef = this._snackBar.open(
    message, 'Close', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: this.durationInSeconds * 1000,
    panelClass: ["custom-error-style"]
  });
}

submit() {

  this.showSubmitButton = false;
  if(this.group.valid){
    let isExcludeProjUser: string = 'Y';
    if(this.projectPermissionModal.isExcludeProjectUser == false)
    {
       isExcludeProjUser = 'N';
    }
    else{
      isExcludeProjUser = 'Y';
    }
     this._projectPermissionService.getUserProjectPermission(this.projectPermissionModal, this.projectPermissionModal.loggedInuserId).subscribe(
      (data: any) => {  
        if(data.body.toUpperCase() == "SUCCESS")     
        { 
          this.openSnackBar(this.ProjectPermissionSuccessMessage);                 
          this.GetProjectAccessUsers(this.projectPermissionModal.PROJECT_ID, isExcludeProjUser);       
        }
      },
      (error: any) => {
          this.openErrorSnackBar(this.ErrorMessage)
      }   
    )
  }
}

reset() {
  this.group.reset(); 
  this.group.controls['isExcludeProjectUser'].setValue(true);  
  this.projectPermissionModal.isExcludeProjectUser = true;
  this.hasData = false;
}

ConstructTheTable(){
  if (this.result.length > 0) {  
    this.dataSource = new MatTableDataSource(this.result as any[]);  
    this.displayedColumns = ['Revoke',...Object.keys(this.result[0])];
    this.columns_to_display_in_table = this.displayedColumns;
    this.columns_to_display_in_table = this.columns_to_display_in_table.map(function(obj){
      if(obj =='USER_NAME')
      {
         obj = 'USER NAME'                 
      }
      if(obj =='USER_VALIDITY')
      {
         obj = 'USER VALIDITY'                 
      }
      return obj; 
})
let i;
for(i = 0; i < this.result.length; i++){
    this.result[i]['USER NAME'] = this.result[i]['USER_NAME'];
    this.result[i]['USER VALIDITY'] = this.result[i]['USER_VALIDITY'];
    this.result[i]['USER VALIDITY'] = this._datePipe.transform(this.result[i]['USER VALIDITY'], 'yyyy-MM-dd');
    delete this.result[i]['USER_NAME'];
    delete this.result[i]['USER_VALIDITY'];
}            
    this.hasData = true;
  } 
  else {            
    this.hasData = false;
  }
}
}
